import { render, staticRenderFns } from "./PropertiesView.vue?vue&type=template&id=d6de2a10&scoped=true"
import script from "./PropertiesView.vue?vue&type=script&lang=ts"
export * from "./PropertiesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6de2a10",
  null
  
)

export default component.exports